<template>
  <div>
    <v-card class="set-height-menu">
      <v-list v-for="item in menu" :key="item.title" class="padding-left" v-model="item.active">
        <template v-if="item.subMenu.length > 0">
          <v-list-group
            v-on:click="
              () => {
                item.active ? (item.active = false) : (item.active = true);
              }
            "
            class="group-list-sidebar"
            :class="{ 'active-menu-list': item.active === true }"
            append-icon="fas fa-caret-down"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title" class="menus"></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="subItem in item.subMenu"
              :key="subItem.title"
              @click="clickMainMenu(null)"
            >
              <span></span>
              <v-list-item-content class="sub-menu" @click="goToPath(subItem.path)">
                <v-list-item-title
                  v-text="subItem.title"
                  :class="{
                    'active-menu-item':
                      $route.path == subItem.path || $route.path == subItem.path_edit
                  }"
                >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <template v-else>
          <v-list-item style="margin-left: -23px" @click="clickMainMenu(item.path)">
            <v-list-item-icon>
              <!---icon--->
            </v-list-item-icon>
            <v-list-item-title v-text="item.title" class="menus">
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "MenuSidebar",
  data() {
    return {
      menu: [
        {
          title: "Customer Support",
          active: false,
          subMenu: [
            {
              title: "Venue Hire",
              path: "/customer-support/venue-hire",
              path_edit: "/customer-support/venue-hire/edit"
            },
            {
              title: "Group Visit",
              path: "/customer-support/group-visit",
              path_edit: "/customer-support/group-visit/edit"
            },
            {
              title: "Contact",
              path: "/customer-support/contact",
              path_edit: "/customer-support/contact/edit"
            }
          ]
        },
        {
          title: "Branch",
          active: false,
          subMenu: [
            {
              title: "Main Branch",
              path: "/branch/main-branch",
              path_edit: "/branch/edit"
            },
            {
              title: "Mini TCDC",
              path: "/branch/mini-TCDC",
              path_edit: "/mini-tcdc/edit"
            },
            {
              title: "Mini TCDC Type",
              path: "/branch/tcdc-mini-type",
              path_edit: "/tcdc-mini-type/edit"
            }
          ]
        },
        {
          title: "Service",
          active: false,
          subMenu: [
            {
              title: "Service",
              path: "/services/service",
              path_edit: "/service/edit"
            },
            {
              title: "Service area",
              path: "/services/service-area",
              path_edit: "/services-area/edit"
            },
            {
              title: "Group visit",
              path: "/services/group-visit",
              path_edit: "/group-visit/edit"
            },
            {
              title: "Travel Info",
              path: "/services/travel-info",
              path_edit: "/travel-info/edit"
            },
            {
              title: "Restaurant",
              path: "/services/restaurant",
              path_edit: "/restaurant/edit"
            },
            {
              title: "Venue hire",
              path: "/services/venue-hire",
              path_edit: "/venue-hire/edit"
            },
            {
              title: "Venue hire detail",
              path: "/services/venue-hire-details",
              path_edit: "/venue-hire-details/edit"
            },
            {
              title: "Floor",
              path: "/services/floor",
              path_edit: "/floor/edit"
            }
          ]
        },
        {
          title: "Menu",
          active: false,
          subMenu: [{ title: "Menu", path: "/menu/menu", path_edit: "/menu/edit" }]
        },
        {
          title: "Resource center",
          active: false,
          subMenu: [
            { title: "Resource center", path: "/resource-center", path_edit: "/resource-center/edit" },
            { title: "Online Exhibition", path: "/online-exhibition", path_edit: "/online-exhibition/edit" }
          ]
        },
        {
          title: "Membership",
          active: false,
          subMenu: [
            {
              title: "Membership",
              path: "/membership",
              path_edit: "/membership/edit"
            },
            {
              title: "Membership rate",
              path: "/membership/membership-rate",
              path_edit: "/membership-rate/edit"
            },
            {
              title: "Membership benefit",
              path: "/membership/membership-benefit",
              path_edit: "/membership-benefit/edit"
            },
            {
              title: "TCDC member",
              path: "/membership/members",
              path_edit: "/members/edit"
            }
          ]
        },
        {
          title: "Design world calendar",
          active: false,
          path: "/design-world-calendar",
          path_edit: "/design-world-calendar/edit",
          subMenu: []
        },
        {
          title: "About",
          active: false,
          subMenu: [
            { title: "About", path: "/about/about", path_edit: "/about/edit" },
            {
              title: "Network",
              path: "/about/network",
              path_edit: "/network/edit"
            },
            { title: "News", path: "/about/news", path_edit: "/news/edit" },
            { title: "Partner", path: "/about/partner", path_edit: "/partner/edit" },
            { title: "Sponser program", path: "/about/sponser-program", path_edit: "/sponser-program/edit" },
            { title: "Location", path: "/about/location", path_edit: "/location/edit" },
            { title: "Contact", path: "/about/contact", path_edit: "/contact/edit" }
          ]
        },
        {
          title: "FAQ",
          active: false,
          subMenu: [
            { title: "FAQ", path: "/fag/faqs", path_edit: "/faqs/edit" },
            { title: "FAQ category", path: "/faq/faq-category", path_edit: "/faq-category/edit" },
          ]
        },
        {
          title: "Banner",
          active: false,
          path: "/banner",
          path_edit: "/banner/edit",
          subMenu: []
        },
        {
          title: "Landing page",
          active: false,
          path: "/landing-page",
          path_edit: "/landing-page/edit",
          subMenu: []
        },
        {
          title: "Free page",
          active: false,
          subMenu: []
        },
        {
          title: "User management",
          active: false,
          subMenu: [
            { title: "User", path: "/user/users", path_edit: "/users/edit" },
            { title: "User role", path: "/user/user-role", path_edit: "/user-role/edit" },
          ]
        },
      ]
    };
  },
  methods: {
    clickMainMenu(path) {
      if(path){
        if (this.$route.path !== path) this.$router.push(path);
      }
    },
    goToPath(path) {
      if (path) {
        if (this.$route.path !== path) this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/css/variables.scss";
.group-list-sidebar {
  .v-icon.v-icon {
    font-size: 15px;
  }
}
.active-menu-list {
  background-color: $background-theme !important;
  border-left: 5px solid $submit-color;
  .v-list-group__items {
    background-color: white;
    border-left: #ffffff !important;
  }
}
.v-list-group__items {
  background-color: white !important;
  border-left: 3px solid #ffffff !important;
  margin-left: -10px;
}
</style>
<style lang="scss" scoped>
@import "src/assets/css/variables.scss";
.theme--light.v-list {
  background: #ffffff;
  color: #000000;
}
div .v-list-item__title {
  color: #000000;
}
.sub-menu {
  margin-left: 30px;
}
.menus {
  font-weight: bold;
}
.set-height-menu {
  height: calc(100vh - 60px);
  background: #ffffff;
  color: #000000;
  width: 20%; /*20*/
  border-color: white !important;
}
.v-list-item__title {
  /*font-size: 20px;*/
}
.v-card {
  display: block;
  max-width: 100%;
  outline: none;
  text-decoration: none;
  -webkit-transition-property: opacity, -webkit-box-shadow;
  overflow-wrap: break-word;
  position: fixed; /*fixed*/
  overflow-y: auto;
  -webkit-transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: box-shadow;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14),
    0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}
@media screen and (max-width: 800px) {
  //for mobile
  .v-card {
    display: block;
    max-width: 100%;
    outline: none;
    text-decoration: none;
    -webkit-transition-property: opacity, -webkit-box-shadow;
    overflow-wrap: break-word;
    position: absolute;
    -webkit-transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
    transition: -webkit-box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
    will-change: box-shadow;
    -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14),
      0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  }
  .set-height-menu {
    height: calc(100vh - 10px);
    background: #ffffff;
    color: #000000;
    width: 100%;
    border-color: white !important;
    position: relative;
  }
}
.active-menu-item {
  color: $submit-color !important;
  font-size: 18px;
}
.padding-left {
  padding-left: 20px;
}
</style>
